'use client';

import React, { useState, useEffect } from 'react';
import { AlertTriangle, X, Info } from 'lucide-react';

export default function BrowserCompatWarning() {
  const [supported, setSupported] = useState<boolean | null>(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    setSupported('showDirectoryPicker' in window);
  }, []);

  if (supported === null || dismissed) return null;

  if (supported) {
    return (
      <div className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-info-bg border border-info-border text-info text-sm fade-in">
        <Info size={15} className="shrink-0" />
        <span>
          Browser compatível detectado. A File System Access API está disponível.
        </span>
        <button
          onClick={() => setDismissed(true)}
          className="ml-auto p-0.5 rounded hover:bg-info/10 transition-colors"
          aria-label="Fechar aviso"
        >
          <X size={14} />
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-start gap-3 px-4 py-3.5 rounded-lg bg-error-bg border border-error-border fade-in">
      <AlertTriangle size={18} className="text-error shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-error">
          Browser não compatível
        </p>
        <p className="text-sm text-error/80 mt-0.5">
          Esta aplicação requer a <strong>File System Access API</strong>, disponível apenas em browsers baseados em Chromium. Firefox e Safari não são suportados.
        </p>
        <div className="flex items-center gap-2 mt-2">
          <span className="text-xs text-error/70">
            Por favor use <strong>Google Chrome</strong> ou <strong>Microsoft Edge</strong> (versão 86+)
          </span>
        </div>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="p-0.5 rounded hover:bg-error/10 transition-colors text-error"
        aria-label="Fechar aviso"
      >
        <X size={14} />
      </button>
    </div>
  );
}